module.exports = __webpack_public_path__ + "img/img-owljourney.d54a4b5c.svg";